module.exports = __webpack_public_path__ + "static/media/admIcon.37ddbb2a.svg";